import { Flex, Icon, Text, Heading } from "@amzn/storm-ui";
import { sparkleSolid } from "@amzn/storm-ui-icons";
import pluralize from "pluralize";
import React from "react";
import styled from "styled-components";

import {
    StyledInsightSheetBody,
    StyledInsightSheetHeader,
} from "../discovery/insights/insightDetails/styles";

export const StyledRelevantInsightSheetBody = styled(StyledInsightSheetBody)`
    width: 45vw;
`;

export const StyledRelevantInsightSheetHeader = styled(
    StyledInsightSheetHeader,
)`
    display: flex;
    flex-flow: column;
    gap: 15px;
`;

const RelevantInsightBannerContainer = styled(Flex)`
    background: ${({ theme }) => theme.color.gray[75]};
    padding: 15px;
    border-radius: 10px;
    gap: 10px;
`;

export const RelevantInsightTitle: React.FC<{ numPages: number }> = ({
    numPages,
}) => {
    return (
        <Heading renderAs="h5" data-testid="relevant-insight-sheet-title">
            Suggested insights
            <Text color="tertiary" inline>
                {pluralize("slide", numPages, true)}
            </Text>
        </Heading>
    );
};

export const RelevantInsightBanner: React.FC = () => {
    return (
        <RelevantInsightBannerContainer
            alignItems="center"
            data-testid="relevant-insight-sheet-banner"
        >
            <Icon size="medium" type={sparkleSolid} />
            <Text>
                These Al-suggested slides can compliment your main presentation
                deck with data-driven insights.
            </Text>
        </RelevantInsightBannerContainer>
    );
};
